export default __webpack_public_path__ + "static/shanhui1-bd32938ecf6a9b247bdd97a5036ca08e.jpg";